/*

Ashraf 09/26/2022 2699242124 change label of reset buttons to reset
Ashraf 09/29/2022 2699242124 fixed bugs on add custom window
Ashraf 10/06/2022 2699242124 added comments to code, removed unusual code
T Santosh Kumar 10/31/2022 2699242124 UI Alignment for Custom Window delete popup.

*/

import React from 'react';
import {Button, Grid, Typography} from '@material-ui/core';
import inputStyles from '../../../components/InputStyles';
import {DeleteField as deleteField} from '../../../redux/reducers/UserDefinedWindow';
import {useDispatch} from 'react-redux';

// delete field popup
export default function DeleteForm({initialValues, setDeleteData, deleteData, handleClose, handleDeleteSubmit, data, setOldFieldName,
  setFieldOperation}) {
  const classes = inputStyles();
  const dispatch = useDispatch();

  // deleting a field after submit
  const handleSubmit = () => {
    if (!deleteData?.windowFieldId) {
      handleDeleteSubmit();
    } else if (deleteData?.windowFieldId) {
      dispatch(deleteField({
        tableFieldName: deleteData?.fieldLabel ? deleteData?.fieldName : '',
        tableName: initialValues?.dbTableView ? initialValues?.dbTableView : '',
        windowCode: initialValues?.windowCode ? initialValues?.windowCode : '',
        windowFieldId: deleteData?.windowFieldId ? deleteData?.windowFieldId : '',
        fieldType: deleteData?.fieldType ? deleteData?.fieldType : '',
        fieldLabel: deleteData?.fieldLabel ? deleteData?.fieldLabel : '',
      }));
    }
    handleClose();
  };
  return (
    <Grid container>
      <Grid xs={12} className="text-center">
        <Typography variant="h4" className="global-field-textfields">
          Are you sure you want to delete {`"${deleteData?.fieldLabel ? deleteData?.fieldLabel : ''}"`} field?
        </Typography>
        <div className="mt-3 mb-2">
          <Button variant="outlined" className={`mx-1 reset-btn ${classes.buttonRoot}`} onClick={() => {
            handleClose();
            setDeleteData({});
          }} >
            <span>No</span>
          </Button>
          <Button variant="outlined" className={`mx-1 search-btn ${classes.buttonRoot}`} onClick={handleSubmit}>
            <span>Yes</span>
          </Button>
        </div>
      </Grid>
    </Grid>
  );
}
